export default "__VITE_ASSET__Bh9bAiyU__"